/**
 * Inline markdown renderer for chat messages (PR-D2 decomposition).
 *
 * Extracted from the original 1,577-line MaestroChatPanel.tsx per gist I19.
 */

import React from 'react';
import { Box } from '@mui/material';
import ReactMarkdown from 'react-markdown';

const MarkdownMessage: React.FC<{ content: string }> = ({ content }) => (
  <Box
    sx={{
      mt: 0.5,
      '& p': { my: 0.5 },
      '& ul, & ol': { my: 0.5, pl: 2.5 },
      '& code': {
        fontFamily: 'monospace',
        backgroundColor: 'rgba(0,0,0,0.06)',
        px: 0.4,
        py: 0.15,
        borderRadius: 0.5,
      },
    }}
  >
    <ReactMarkdown>{content || ''}</ReactMarkdown>
  </Box>
);

export default MarkdownMessage;
